import React from 'react';
import { shape, arrayOf, func, string, bool, object, number, oneOfType } from 'prop-types';
import ActiveFiltersSection from '../active-filters/';
import FiltersSection from '../filters/';

export default function FiltersLayout({
    filters, activeFilters, filterSettings, toggleFilters, resetFilters,
    resetFilterGroup, focusedFilter, toggleFocus, mainState
}) {
    if (!filters || !filters.length) { return null; }

    return (
        <div className="filters-layout">
            <FiltersSection
                mainState={mainState}
                filters={filters}
                filterSettings={filterSettings}
                activeFilters={activeFilters}
                toggleFilters={toggleFilters}
                resetFilterGroup={resetFilterGroup}
                focusedFilter={focusedFilter}
                toggleFocus={toggleFocus}
            />

            <ActiveFiltersSection
                activeFiltersStyle={filterSettings.activeFiltersStyle}
                activeFiltersLabel={filterSettings.activeFiltersLabel}
                activeFilters={activeFilters}
                showActiveFilters={filterSettings.showActiveFilters}
                resetFilters={resetFilters}
                toggleFilters={toggleFilters}
            />
        </div>
    );
}

FiltersLayout.propTypes = {
    /* eslint-disable react/no-typos */
    /* eslint-disable react/forbid-prop-types */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    filters: arrayOf(shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(oneOfType([string, bool, number]))
    })).isRequired,
    activeFilters: arrayOf(shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(oneOfType([string, bool, number])).isRequired
    })).isRequired,
    filterSettings: shape({
        itemsPerPage: number,
        showResultCount: bool,
        showActiveFilters: bool,
        activeFiltersStyle: string,
        activeFiltersLabel: string,
        keywordPlaceholderText: string,
        keywordSearchableFields: arrayOf(string),
        sortBy: arrayOf(object)
    }).isRequired,
    toggleFilters: func.isRequired,
    resetFilters: func.isRequired,
    resetFilterGroup: func.isRequired,
    focusedFilter: string,
    toggleFocus: func.isRequired,
    mainState: object.isRequired
    /* eslint-enable react/no-typos */
};

FiltersLayout.defaultProps = { focusedFilter: null };



// WEBPACK FOOTER //
// ./src/components/filtered-listing/layouts/FiltersLayout.jsx